// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-page);
  color: var(--text-primary);
}

.layout__main {
  flex: 1 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/shared/layouts/MainLayout/MainLayout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB","sourcesContent":[".layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-page);\n  color: var(--text-primary);\n}\n\n.layout__main {\n  flex: 1;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2.5rem 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
